import { SectionCard } from "../../ui/section-card";
import { factList, plainList, subheading } from "../components/styles";
import { formatDateTime, sourceKindLabels } from "../labels";
import type { ItemSectionContext } from "./section-support";

/** Where the item came from: its source, its imports and its references in other systems. Read-only. */
export function ReferencesPanel({ ctx }: Readonly<{ ctx: ItemSectionContext }>) {
  const { detail } = ctx;
  return (
    <SectionCard
      id="references"
      title="Source and references"
      description="Where this item came from. These facts are read-only."
    >
      <dl className={factList}>
        <div>
          <dt>Source</dt>
          <dd>{sourceKindLabels[detail.item.sourceKind]}</dd>
        </div>
        <div>
          <dt>Created</dt>
          <dd>{formatDateTime(detail.item.createdAt)}</dd>
        </div>
        <div>
          <dt>Last changed</dt>
          <dd>{formatDateTime(detail.item.updatedAt)}</dd>
        </div>
      </dl>
      {detail.sources.length > 0 ? (
        <>
          <h3 className={subheading}>Import sources</h3>
          <ul className={plainList}>
            {detail.sources.map((source) => (
              <li key={`${source.sourceSystem}:${source.sourceKey}`}>
                {source.sourceSystem} · {source.sourceKey} · {formatDateTime(source.createdAt)}
              </li>
            ))}
          </ul>
        </>
      ) : null}
      {detail.externalRefs.length > 0 ? (
        <>
          <h3 className={subheading}>External references</h3>
          <ul className={plainList}>
            {detail.externalRefs.map((ref) => (
              <li key={`${ref.provider}:${ref.externalId}`}>
                {ref.provider} · {ref.externalId} · observed {formatDateTime(ref.observedAt)}
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </SectionCard>
  );
}
